import React from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormDropdown, FormFields, FormTextField } from "sprint-common-web";

import { EditLanguageCodeMappingFormInputs } from "./EditMappingFormInputs";
import { useEditLanguageCodeMappingForm } from "./useEditMappingForm";

export interface EditMappingFormProps {
    languageId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const EditMappingForm: React.VFC<EditMappingFormProps> = ({
    languageId,
    onSubmit,
    onCancel
}: EditMappingFormProps) => {
    const { itemToEdit, editMapping, languageOptions } = useEditLanguageCodeMappingForm(languageId);

    const { errors, control, formState, handleSubmit } = useForm<EditLanguageCodeMappingFormInputs>({
        defaultValues: {
            languageId: itemToEdit.languageId,
            soundtrackCode: itemToEdit.soundtrackCode,
            subtitleCode: itemToEdit.subtitleCode
        },
        criteriaMode: "all"
    });

    const handleEditLanguageCodeMapping = async (inputs: EditLanguageCodeMappingFormInputs) => {
        await editMapping(inputs);
        onSubmit();
    };

    const handleCancelButtonClick = () => {
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleEditLanguageCodeMapping)}>
            <FormFields>
                <FormDropdown
                    label="Language"
                    name="languageId"
                    control={control}
                    errors={errors}
                    disabled={true}
                    options={languageOptions}
                />
                <FormTextField
                    control={control}
                    errors={errors}
                    name="soundtrackCode"
                    label="Soundtrack code"
                    rules={{
                        required: "Soundtrack code is required field"
                    }}
                />
                <FormTextField
                    control={control}
                    errors={errors}
                    name="subtitleCode"
                    label="Subtitle code"
                    rules={{
                        required: "Subtitle code is required field"
                    }}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isValidating || formState.isSubmitting}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
